export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="rounded-lg bg-background-50 border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-smartphone-line text-2xl text-accent-500"></i>
                </div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
                  移动观影
                </h2>
              </div>
              <p className="text-sm text-foreground-400 mb-6 ml-11">
                随时随地，畅享悟空影视高清观影体验
              </p>

              <div className="ml-11 space-y-3">
                <p className="text-sm text-foreground-300 leading-relaxed">
                  悟空影视已完成全面的移动端适配。无需下载任何APP，通过手机浏览器即可访问，支持手势控制播放进度、音量调节和亮度调整。
                </p>
                <div className="flex flex-wrap items-center gap-4 pt-2">
                  <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-all">
                    <i className="ri-android-line text-primary-400"></i>
                    <span className="text-xs text-foreground-300 whitespace-nowrap">浏览器访问</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-all">
                    <i className="ri-apple-line text-primary-400"></i>
                    <span className="text-xs text-foreground-300 whitespace-nowrap">Safari 打开</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-all">
                    <i className="ri-cast-line text-primary-400"></i>
                    <span className="text-xs text-foreground-300 whitespace-nowrap">支持投屏</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-[320px] p-6 lg:p-0 flex justify-center">
              <div className="relative w-[200px] h-[340px] rounded-2xl overflow-hidden border-2 border-background-300/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20modern%20movie%20streaming%20app%20interface%20with%20movie%20posters%20grid%2C%20warm%20dark%20theme%20design%2C%20amber%20and%20golden%20accent%20colors%2C%20clean%20UI%20layout%20with%20film%20thumbnails%2C%20professional%20app%20design%2C%20minimalist%20interface%2C%20dark%20background&width=400&height=680&seq=wukong-app-mock&orientation=portrait"
                  alt="悟空影视移动端观影界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}